import { defineStore } from 'pinia';

import {
  PhysicalPrepaidCardSettingRepository,
  PhysicalPrepaidCardSettingResponse,
} from '@/repositories/generated';

type PhysicalPrepaidCardSettingState = Partial<{
  physicalPrepaidCardSetting: PhysicalPrepaidCardSettingResponse;
}>;

export const usePhysicalPrepaidCardSettingStore = defineStore('physicalPrepaidCardSetting', {
  state: (): PhysicalPrepaidCardSettingState => ({
    physicalPrepaidCardSetting: undefined,
  }),
  actions: {
    async getPhysicalPrepaidCardSetting(): Promise<PhysicalPrepaidCardSettingResponse> {
      if (this.physicalPrepaidCardSetting) {
        return this.physicalPrepaidCardSetting;
      }

      this.physicalPrepaidCardSetting = await PhysicalPrepaidCardSettingRepository.get();

      return this.physicalPrepaidCardSetting;
    },
  },
});
